import React from 'react';
import { Box, Button, ButtonGroup, Card, CardContent, Divider, Grid, makeStyles, Stack, Typography } from '@mui/material'
import stylesheet from '../detail-container.stylesheet'
import { ClassNameMap, withStyles } from '@mui/styles'

interface IProps {
  id: number,
  header: string,
  outerDelete: any,
  closeDelete: any
  classes: ClassNameMap;
}

const DeleteCard: React.FC<IProps> = ({ id, header, closeDelete, outerDelete, classes }) => {
  const handelCloseDelete = () => {
    closeDelete(id);
  }
  const handleOuterDelete = () => {
    outerDelete(id);
  }

  return (
    <Box mb={1} className={classes.customDeleteCard}>
      <Card variant="outlined" className={classes.deleteCardContainer}>
        <CardContent sx={{ padding: '0.5rem 0.8rem 0.5rem 0.8rem' }}>
          <Stack direction={'column'} spacing={0.5}>
            <Typography variant="subtitle2" className={classes.subHeadername}>
              {header}
            </Typography>
            <Divider />
          </Stack>
          <Box pt={1} pb={1}>
            <Typography variant="subtitle2" className={classes.desc}>
              Are you sure you want to delete this?
            </Typography>
          </Box>
        </CardContent>

        <Grid xs={12} direction="row" justifyContent="space-around" alignItems="center">
          <ButtonGroup
            className={classes.deleteButtonStyle}
            size="small"
            variant="text"
            aria-label="small outlined button group"
          >
            <Button
              onClick={handleOuterDelete}
              className={classes.deleteButtonWidth}
              data-testid='delete-button'
            >
              <strong>Delete</strong></Button>
            <Button
              onClick={handelCloseDelete}
              className={classes.deleteButtonWidth}
              data-testid='cancel-button'
            >
              <strong>Cancel</strong>
            </Button>
          </ButtonGroup>
        </Grid>
      </Card>
    </Box>
  )
}


export default withStyles(stylesheet)(DeleteCard)